import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarClock } from "lucide-react";
import api from "../../lib/api";

const fmt = (d) => new Date(`${d}T12:00:00`).toLocaleDateString("en-US", { month: "short", day: "numeric" });
const money = (v) => (v ? `$${Math.round(v).toLocaleString()}/mo` : "");

export function RenewalsPanel({ location }) {
  const [items, setItems] = useState(null);
  const [tab, setTab] = useState("renewal");
  const [all, setAll] = useState(false);
  useEffect(() => { api.get("/home/renewals").then(({ data }) => setItems(data.items)).catch(() => setItems([])); }, []);
  if (!items) return <div className="h-24 rounded-xl bg-brand-hover animate-pulse" />;
  const scoped = location ? items.filter((i) => i.location === location) : items;
  const counts = { renewal: scoped.filter((i) => i.kind === "renewal").length, notice: scoped.filter((i) => i.kind === "notice").length };
  const list = scoped.filter((i) => i.kind === tab);
  const shown = all ? list : list.slice(0, 8);
  return (
    <div className="bg-white border border-brand-border rounded-xl" data-testid="home-renewals">
      <div className="flex flex-wrap items-center gap-2 px-5 pt-4">
        {[["renewal", "Up for renewal"], ["notice", "Moving out (on notice)"]].map(([k, label]) => (
          <button key={k} onClick={() => { setTab(k); setAll(false); }} data-testid={`home-renewals-tab-${k}`}
            className={`text-xs rounded-full px-3 py-1.5 border transition-colors ${tab === k ? "bg-brand-ink text-brand-page border-brand-ink" : "border-brand-border text-brand-ink hover:border-brand-ink"}`}>
            {label} · {counts[k]}
          </button>
        ))}
        <span className="ml-auto text-xs text-brand-tertiary">Next 60 days{location ? ` · ${location}` : ""}</span>
      </div>
      {!list.length ? <p className="px-5 py-5 text-sm text-brand-muted" data-testid="home-renewals-empty">Nothing ending in the next 60 days.</p> : (
        <ul className="divide-y divide-brand-border mt-3">
          {shown.map((i) => (
            <li key={`${i.company_id}-${i.end}-${i.location}`}>
              <Link to={`/members?q=${encodeURIComponent(i.company_name)}`} data-testid={`home-renewal-${i.company_id}`} className="flex items-center gap-4 px-5 py-3 hover:bg-brand-hover transition-colors">
                <span className={`w-14 shrink-0 text-center rounded-lg py-1 ${i.days <= 14 ? "bg-rose-50 text-rose-800" : "bg-brand-hover text-brand-ink"}`}>
                  <span className="block font-serif text-lg leading-none">{i.days}</span><span className="text-[9px] uppercase tracking-[0.1em]">days</span>
                </span>
                <span className="flex-1 min-w-0">
                  <span className="block text-sm text-brand-ink truncate">{i.company_name}</span>
                  <span className="block text-xs text-brand-muted truncate">{[i.location, i.offices.length ? `Office ${i.offices.join(", ")}` : null, i.term_months ? `${i.term_months}-mo term` : null, i.kind === "renewal" ? (i.auto_renew === "Yes" ? "auto-renews" : "no auto-renew") : null].filter(Boolean).join(" · ")}</span>
                </span>
                <span className="text-right shrink-0">
                  <span className="block text-sm text-brand-ink inline-flex items-center gap-1"><CalendarClock className="h-3.5 w-3.5 text-brand-tertiary" /> {fmt(i.end)}</span>
                  <span className="block text-xs text-brand-tertiary">{money(i.mrr)}</span>
                </span>
              </Link>
            </li>
          ))}
        </ul>
      )}
      {list.length > 8 && <button onClick={() => setAll(!all)} data-testid="home-renewals-more" className="w-full text-xs text-brand-muted hover:text-brand-ink py-3 border-t border-brand-border transition-colors">{all ? "Show fewer" : `Show all ${list.length}`}</button>}
    </div>
  );
}
